var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { DATE_FORMAT, DATE_FORMAT_INCLUDE_TIME } from 'renderer/constants';
import Button from 'antd/lib/button';
import { Col } from 'antd/lib/grid';
import Row from 'antd/lib/row';
import Tabs from 'antd/lib/tabs';
import TabPane from 'rc-tabs/lib/TabPanelList/TabPane';
import { Controller, useForm } from 'react-hook-form';
import { IMAGES } from 'renderer/assets';
import { ManagerQuery, ProductQuery, StoreQuery } from 'renderer/queries';
import { get, set, useWindowSize, orderBy, LambdaClient } from 'renderer/utils';
import styled from 'styled-components';
import { ScrollBar, Icon, EntireBigTitleModal, HookFormInputs, TextComponent, useEntireLoader, CustomDropdown, FloatingButtonGroup, useNaverBlockingValue, BigTitleModal, DatePickerAutoaccept } from 'renderer/components';
import Tooltip from 'antd/lib/tooltip';
import Card from 'antd/lib/card';
import Alert from 'antd/lib/alert';
import notification from 'antd/lib/notification';
import dayjs from 'dayjs';
import Switch from 'antd/lib/switch';
import Checkbox from 'antd/lib/checkbox';
import Spin from 'antd/lib/spin';
import { useNaverBlocking } from './plussharp/NaverBlockingStatus';
import { SmartPlcaceSetter } from './NewNaver';
export var NaverBlockModal = function (props) {
    var _a, _b, _c, _d, _e;
    var store = StoreQuery.getMyStoreInCache();
    var _f = React.useState(props.targetDate), date = _f[0], setDate = _f[1];
    React.useEffect(function () {
        setDate(props.targetDate);
    }, [props.targetDate]);
    var blockSettings = ((_b = (_a = store === null || store === void 0 ? void 0 : store.preference) === null || _a === void 0 ? void 0 : _a.naverSmartPlace) === null || _b === void 0 ? void 0 : _b.blockSettings) || ((_d = (_c = store === null || store === void 0 ? void 0 : store.preference) === null || _c === void 0 ? void 0 : _c.smartplace) === null || _d === void 0 ? void 0 : _d.blockSettings);
    var typeString = (_e = blockSettings === null || blockSettings === void 0 ? void 0 : blockSettings.types) === null || _e === void 0 ? void 0 : _e.map(function (type) { return (type === 'reservation' ? '예약' : type === 'off' ? '휴무' : '일정'); }).join(',');
    var _g = useNaverBlocking(), status = _g[0], startBlocking = _g[1];
    return (React.createElement(BigTitleModal, { centered: true, open: !!props.targetDate, okButtonProps: { disabled: status === 'pending' }, onOk: function () {
            startBlocking({
                effectedDates: [date],
                storeId: store.id
            });
            props.onClose();
        }, onCancel: props.onClose, okText: "\uB124\uC774\uBC84\uC608\uC57D \uB9C9\uAE30", title: "\uB124\uC774\uBC84 \uC608\uC57D \uB9C9\uAE30", children: React.createElement("div", { style: { padding: '20px' } },
            React.createElement(DatePickerAutoaccept, { value: dayjs(date), inputReadOnly: true, showNow: false, onChange: function (value) { return setDate(value.toDate()); } }),
            React.createElement(TextComponent, { marginTop: 20, children: "".concat(dayjs(date).format(DATE_FORMAT), "\uC758 ").concat(typeString, ",\uC0C1\uC810\uC601\uC5C5\uC2DC\uAC04\uC5D0 \uB530\uB77C \uB124\uC774\uBC84\uC608\uC57D \uCE98\uB9B0\uB354\uB97C \uC870\uC815\uD569\uB2C8\uB2E4.") })) }));
};
export var NaverSmartPlaceCrawler = function (props) {
    var _a, _b;
    var isBeta = !!((_b = (_a = props.store) === null || _a === void 0 ? void 0 : _a.preference) === null || _b === void 0 ? void 0 : _b.naverSmartPlace);
    return isBeta ? React.createElement(PrevNaverSmartPlaceCrawler, __assign({}, props)) : React.createElement(SmartPlcaceSetter, __assign({}, props));
};
export var PrevNaverSmartPlaceCrawler = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _j = React.useState(), visible = _j[0], setVisible = _j[1];
    var _k = React.useState(), targetDate = _k[0], setTargetDate = _k[1];
    var shouldShowNaver = (_a = props.store.preference) === null || _a === void 0 ? void 0 : _a.shouldShowNaver;
    var blockActive = (_e = (_d = (_c = (_b = props.store) === null || _b === void 0 ? void 0 : _b.preference) === null || _c === void 0 ? void 0 : _c.naverSmartPlace) === null || _d === void 0 ? void 0 : _d.blockSettings) === null || _e === void 0 ? void 0 : _e.isActive;
    var height = useWindowSize().height;
    var blockingValue = useNaverBlockingValue();
    var isInvalidNaverId = (_h = (_g = (_f = props.store) === null || _f === void 0 ? void 0 : _f.preference) === null || _g === void 0 ? void 0 : _g.naverSmartPlace) === null || _h === void 0 ? void 0 : _h.isInvalidNaverId;
    var _l = React.useState(true), tooltip = _l[0], setTooltip = _l[1];
    var isPending = blockingValue.status === 'pending';
    var width = '32px';
    return shouldShowNaver ? (isInvalidNaverId ? (React.createElement(Tooltip, { title: React.createElement("div", { style: { display: 'flex', alignItems: 'top' } },
            "\uB124\uC774\uBC84\uC5F0\uB3D9\uC5D0 \uBB38\uC81C\uAC00 \uC788\uC2B5\uB2C8\uB2E4. \uACE0\uAC1D\uC13C\uD130\uC5D0 \uC5F0\uB77D\uD574\uC11C \uC7AC\uC5F0\uB3D9\uD574\uC8FC\uC138\uC694.",
            React.createElement(Icon, { name: "x", size: 32, onClick: function () { return setTooltip(false); } })), placement: "topRight", open: tooltip },
        React.createElement("img", { src: IMAGES.schedule_icon_naver_error, style: { width: width, height: width }, onClick: function () {
                setTooltip(true);
            } }))) : (React.createElement(React.Fragment, null,
        React.createElement(CustomDropdown, { disabled: isPending || isInvalidNaverId, items: [
                {
                    name: 'pull',
                    label: '예약 시간막기',
                    disabled: !blockActive,
                    onClick: function () {
                        setTargetDate(props.currentDate);
                    }
                },
                // {
                //   name: 'pull',
                //   label: '예약 가져오기 최근 업데이트 : 2022-04-26 14:28',
                //   onClick: () => {},
                //   disabled: true
                // },
                {
                    name: 'settings',
                    label: '네이버예약 설정',
                    onClick: function () {
                        setVisible(true);
                    }
                }
            ] }, isPending ? (React.createElement(Spin, { size: "small" })) : (React.createElement("img", { src: IMAGES.schedule_icon_naver, style: { width: width, height: width } }))),
        React.createElement(NaverBlockModal, { targetDate: targetDate, onClose: function () { return setTargetDate(null); } }),
        React.createElement(EntireBigTitleModal, { visible: visible, title: "\uB124\uC774\uBC84 \uC608\uC57D BETA", children: React.createElement(ScrollBar, { style: { height: "".concat(height - 55, "px"), padding: '20px' } },
                React.createElement(LegacySettings, { store: props.store })), footer: null, onCancel: function () {
                setVisible(false);
            } })))) : (React.createElement("div", null));
};
var LegacySettings = function (props) {
    var _a;
    var form = useForm();
    var loader = useEntireLoader();
    var handleLogin = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loader.show();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, LambdaClient.getInstance().post("/crawler/loginAndSaveNaverAccount", __assign(__assign({}, values), { storeId: props.store.id }), { timeout: 30000 })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, StoreQuery.refreshMyStoreInCache()];
                case 3:
                    _a.sent();
                    notification.success({ message: '네이버 정보 연동 성공' });
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    notification.error({ message: error_1.message || '네이버 로그인에 실패했습니다.' });
                    return [3 /*break*/, 6];
                case 5:
                    loader.hide();
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = form.handleSubmit(handleLogin, function (errors) {
        console.log('onSubmit errors', errors);
    });
    var update = StoreQuery.useUpdateStore();
    var handleUpdate = function (store) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loader.show();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, update.mutateAsync(store)];
                case 2:
                    result = _a.sent();
                    notification.success({ message: '네이버연동 설정이 변경되었습니다.' });
                    return [2 /*return*/, result];
                case 3:
                    error_2 = _a.sent();
                    notification.error({ message: error_2.message || '네이버 로그인에 실패했습니다.' });
                    return [3 /*break*/, 5];
                case 4:
                    loader.hide();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((_a = props.store) === null || _a === void 0 ? void 0 : _a.isAvailableNaverSmartplace) ? (React.createElement(TabContent, null,
        React.createElement(Notice, { messages: [
                '- 본 서비스는 베타서비스입니다.',
                '- 따라서 서비스가 불안하거나 중단될 수 있습니다.',
                '- 1시간 간격으로 예약정보를 수집합니다.',
                '- 네이버 예약은 팅커뷰CRM에서 문자를 발송하지 않습니다.'
            ] }),
        React.createElement(Tabs, { tabBarExtraContent: {
                right: (React.createElement(Tooltip, { placement: "topLeft", title: "\uC2DC\uC220 \uBC0F \uC2A4\uD0C0\uC77C\uB9AC\uC2A4\uD2B8 \uC0C8\uB85C\uACE0\uCE68" },
                    React.createElement(Button, { type: "primary", children: React.createElement(Icon, { name: "refresh", size: 18 }), onClick: function () { return handleLogin({ isRefresh: true }); } })))
            }, defaultActiveKey: "block", onChange: function (key) {
                console.log('key', key);
            } },
            React.createElement(TabPane, { tab: React.createElement(Tab, { label: "\uC5F0\uB3D9\uC815\uBCF4" }), key: "info" },
                React.createElement(NaverInformation, { store: props.store, handleUpdate: handleUpdate })),
            React.createElement(TabPane, { tab: React.createElement(Tab, { label: "\uC2DC\uC220 \uC5F0\uACB0" }), key: "products" },
                React.createElement(ProductOrManagerLink, { store: props.store, type: "products", handleUpdate: handleUpdate })),
            React.createElement(TabPane, { tab: React.createElement(Tab, { label: "\uC9C1\uC6D0 \uC5F0\uACB0" }), key: "managers" },
                React.createElement(ProductOrManagerLink, { store: props.store, type: "managers", handleUpdate: handleUpdate })),
            React.createElement(TabPane, { tab: React.createElement(Tab, { label: "\uC608\uC57D\uAC00\uB2A5\uC2DC\uAC04 \uB3D9\uAE30\uD654" }), key: "block" },
                React.createElement(BlockAvailableTime, { store: props.store, handleUpdate: handleUpdate }))))) : (React.createElement(TabContent, null,
        React.createElement(Card, { title: React.createElement(TextComponent, { children: "\uB124\uC774\uBC84 \uC5F0\uB3D9 \uC815\uBCF4 \uC785\uB825", type: "subtitle2" }) },
            React.createElement(Form, null,
                React.createElement(HookFormInputs.Text, { label: '네이버아이디', controlProps: {
                        name: 'naverId',
                        control: form.control
                    }, inputProps: {} }),
                React.createElement(HookFormInputs.Text, { label: '비밀번호', inputProps: {
                        type: 'password'
                    }, controlProps: {
                        name: 'password',
                        control: form.control
                    } }),
                React.createElement(HookFormInputs.Text, { label: 'BookingBusinessId', controlProps: {
                        name: 'bookingBusinessId',
                        control: form.control
                    }, inputProps: {} }),
                React.createElement(Button, { type: "primary", children: "\uC800\uC7A5", style: { width: '100%' }, onClick: form.handleSubmit(onSubmit) }),
                React.createElement(Notice, { messages: [
                        '- 본 서비스는 베타서비스입니다.',
                        '- 따라서 서비스가 불안하거나 중단될 수 있습니다.',
                        '- 입력하신 아이디와 비밀번호는 암호화되어 안전하게 보관되며 네이버예약 수집 이외의 목적으로 사용되지 않습니다.',
                        '- 아래 메뉴얼에 따라 비밀번호를 생성하시고 생성한 비밀번호를 이용해 로그인해주세요.'
                    ] })))));
};
var Notice = function (props) {
    return (React.createElement(Alert, { message: "\uC77D\uC5B4\uC8FC\uC138\uC694!", description: React.createElement("div", null, props.messages.map(function (message, index) {
            return React.createElement(TextComponent, { key: index }, message);
        })), type: "info" }));
};
var NaverInformation = function (props) {
    var _a;
    var naverSmartPlace = (_a = props.store) === null || _a === void 0 ? void 0 : _a.preference.naverSmartPlace;
    var storeName = get(naverSmartPlace, 'storeInfo.smartplaceBusiness.name');
    var active = get(naverSmartPlace, 'active');
    var deleteWhenCancel = get(naverSmartPlace, 'deleteWhenCancel');
    return (React.createElement(Card, { title: React.createElement(TextComponent, { children: storeName, type: "subtitle2" }) },
        React.createElement(Row, { align: "middle", gutter: 24 },
            React.createElement(Col, null,
                React.createElement(TextComponent, { children: "\uC608\uC57D \uAC00\uC838\uC624\uAE30 ON/OFF", type: "subtitle2" }),
                React.createElement(TextComponent, { children: "(\uB9C8\uC9C0\uB9C9 \uAC00\uC838\uC624\uAE30 : ".concat(naverSmartPlace.lastUpdatedAt
                        ? dayjs(naverSmartPlace.lastUpdatedAt).format(DATE_FORMAT_INCLUDE_TIME)
                        : '없음', ")") })),
            React.createElement(Col, null,
                React.createElement(Switch, { checked: !!active, onChange: function (checked) {
                        try {
                            props.handleUpdate({
                                id: props.store.id,
                                preference: set(props.store.preference, "naverSmartPlace.active", checked)
                            });
                        }
                        catch (error) { }
                    } }))),
        React.createElement(Row, { align: "middle", gutter: 24, style: { marginTop: '30px' } },
            React.createElement(Col, null,
                React.createElement(TextComponent, { children: "\uB124\uC774\uBC84 \uC608\uC57D \uCDE8\uC18C \uC2DC \uD305\uCEE4\uBDF0\uC5D0\uC11C \uC608\uC57D \uC0AD\uC81C", type: "subtitle2", marginRight: 90 })),
            React.createElement(Col, null,
                React.createElement(Switch, { checked: !!deleteWhenCancel, onChange: function (checked) {
                        try {
                            props.handleUpdate({
                                id: props.store.id,
                                preference: set(props.store.preference, "naverSmartPlace.deleteWhenCancel", checked)
                            });
                        }
                        catch (error) { }
                    } })))));
};
var BlockAvailableTime = function (props) {
    var handleReset = function () {
        form.reset(getDefaultValue());
    };
    var getDefaultValue = function () {
        var _a, _b;
        var blockSettings = (_b = (_a = props.store.preference) === null || _a === void 0 ? void 0 : _a.naverSmartPlace) === null || _b === void 0 ? void 0 : _b.blockSettings;
        var newValue = {
            isActive: blockSettings === null || blockSettings === void 0 ? void 0 : blockSettings.isActive,
            isBlockWhenCovered: (blockSettings === null || blockSettings === void 0 ? void 0 : blockSettings.isBlockWhenCovered) || false,
            types: (blockSettings === null || blockSettings === void 0 ? void 0 : blockSettings.types) || ['reservation'],
            useStoreProduct: blockSettings === null || blockSettings === void 0 ? void 0 : blockSettings.useStoreProduct,
            beforeMinute: (blockSettings === null || blockSettings === void 0 ? void 0 : blockSettings.beforeMinute) || 0,
            afterMinute: (blockSettings === null || blockSettings === void 0 ? void 0 : blockSettings.afterMinute) || 0
        };
        return newValue;
    };
    React.useEffect(function () {
        handleReset();
    }, [props.store]);
    var form = useForm({
        defaultValues: getDefaultValue()
    });
    var onSubmit = form.handleSubmit(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var blockSettings, newPreference;
        var _a, _b;
        return __generator(this, function (_c) {
            blockSettings = (_b = (_a = props.store.preference) === null || _a === void 0 ? void 0 : _a.naverSmartPlace) === null || _b === void 0 ? void 0 : _b.blockSettings;
            newPreference = set(props.store.preference, "naverSmartPlace.blockSettings", __assign(__assign({}, (blockSettings || {})), values));
            try {
                props.handleUpdate({
                    id: props.store.id,
                    preference: newPreference
                });
            }
            catch (error) { }
            return [2 /*return*/];
        });
    }); }, function (errors) {
        console.log('onSubmit errors', errors);
    });
    form.watch();
    var _a = form.getValues(), types = _a.types, isBlockWhenCovered = _a.isBlockWhenCovered;
    var options = [
        { value: 'reservation', label: '예약', disabled: true },
        { value: 'schedule', label: '일정' },
        { value: 'off', label: '휴무' }
    ];
    var typeString = (types === null || types === void 0 ? void 0 : types.map(function (key) { return options.find(function (item) { return item.value === key; }).label; }).join(',')) || '';
    var timeOptions = [
        { value: 0, label: '사용안함' },
        { value: 30, label: '30분' },
        { value: 60, label: '1시간' },
        { value: 90, label: '1시간30분' },
        { value: 120, label: '2시간' }
    ];
    return (React.createElement(FormContainer, { formElement: React.createElement("div", null,
            React.createElement(Row, { gutter: 16, align: "middle" },
                React.createElement(Col, null,
                    React.createElement(HookFormInputs.SwitchInput, { inputProps: {
                            checked: form.getValues().isActive
                        }, controlProps: {
                            name: "isActive",
                            control: form.control
                        } })),
                React.createElement(TextComponent, { children: '네이버 예약 막기사용' })),
            React.createElement(TextComponent, { children: "\uC801\uC6A9 \uD56D\uBAA9", type: "subtitle2", marginBottom: 10, marginTop: 20 }),
            React.createElement(SubSettingWrapper, null,
                React.createElement(Controller, { name: "types", control: form.control, rules: { required: true }, render: function (_a) {
                        var field = _a.field;
                        return React.createElement(Checkbox.Group, __assign({}, field, { options: options }));
                    } }),
                React.createElement(TextComponent, { children: "- ".concat(typeString, "\uB4E4\uC774 \uC788\uB294 \uC2DC\uAC04\uB300\uC758 \uB124\uC774\uBC84 \uC608\uC57D\uC744 \uB9C9\uC2B5\uB2C8\uB2E4."), marginTop: 10 })),
            React.createElement(TextComponent, { children: "\uB124\uC774\uBC84 \uC608\uC57D \uAC00\uB2A5 \uC2DC\uAC04 \uC801\uC6A9 \uC815\uCC45 \uC124\uC815", type: "subtitle2", marginTop: 30, marginBottom: 10 }),
            React.createElement(SubSettingWrapper, null,
                React.createElement(HookFormInputs.SelectInput, { label: "\uB124\uC774\uBC84 \uC608\uC57D \uAC00\uB2A5 \uC2DC\uAC04 \uC801\uC6A9 \uC815\uCC45 \uC124\uC815", controlProps: {
                        name: "isBlockWhenCovered",
                        control: form.control
                    }, inputProps: {
                        style: { width: '300px' },
                        placeholder: '담당자 선택',
                        options: [
                            { label: '예약시간 일부가 겹칠 때도 예약막기', value: false },
                            { label: '시간 전체가 겹칠 때만 예약막기', value: true }
                        ]
                    } }),
                React.createElement(TextComponent, { children: isBlockWhenCovered
                        ? '- 14:10~14:20 예약이 있더라도 14:00~14:30 동안 네이버 예약을 허용'
                        : '- 14:10~14:20 예약이 있으면 14:00~14:30 동안 네이버 예약을 금지', marginTop: 10, type: "body3" }),
                React.createElement(TextComponent, { children: isBlockWhenCovered ? '- 14:00~14:30 예약을 등록했다면 14:00~14:30 동안 네이버 예약을 금지' : '', type: "subtitle3", marginBottom: 20 }),
                React.createElement(HookFormInputs.SelectInput, { label: "".concat(typeString, " \uC804 \uC2DC\uAC04 \uCD94\uAC00 \uB9C9\uAE30"), controlProps: {
                        name: "beforeMinute",
                        control: form.control
                    }, inputProps: {
                        style: { width: '300px' },
                        placeholder: '사용안함',
                        options: timeOptions
                    } }),
                React.createElement(HookFormInputs.SelectInput, { label: "".concat(typeString, " \uD6C4 \uC2DC\uAC04 \uCD94\uAC00 \uB9C9\uAE30"), controlProps: {
                        name: "afterMinute",
                        control: form.control
                    }, inputProps: {
                        style: { width: '300px' },
                        placeholder: '사용안함',
                        options: timeOptions
                    } }))), visible: !!form.formState.isDirty, onConfirm: form.handleSubmit(onSubmit), onCancel: handleReset }));
};
var SubSettingWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 10px;\n  padding-left: 20px;\n"], ["\n  padding-top: 10px;\n  padding-left: 20px;\n"])));
var ProductOrManagerLink = function (props) {
    var _a, _b;
    var storeProducts = ProductQuery.getProductsByStoreIdFromCache(props.store.id).products;
    var managerConnects = (_a = props.store) === null || _a === void 0 ? void 0 : _a.managerConnectInfo;
    var productConnects = (_b = props.store) === null || _b === void 0 ? void 0 : _b.productConnectInfo;
    var handleReset = function () {
        var newValues = {};
        if (props.type === 'managers') {
            managerConnects.map(function (connect) {
                newValues[connect.bizItemId] = connect.managerId;
            });
        }
        else {
            productConnects.map(function (connect) {
                newValues[connect.optionId] = connect.storeProductId;
            });
        }
        form.reset(newValues);
    };
    React.useEffect(function () {
        handleReset();
    }, [props.type]);
    React.useEffect(function () {
        handleReset();
    }, [props.store]);
    var form = useForm();
    var managers = ManagerQuery.getWorkingManagersInCache();
    var onSubmit = form.handleSubmit(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var newPreference;
        return __generator(this, function (_a) {
            newPreference = set(props.store.preference, "naverSmartPlace.connectInfo.".concat(props.type), values);
            try {
                props.handleUpdate({
                    id: props.store.id,
                    preference: newPreference
                });
            }
            catch (error) { }
            return [2 /*return*/];
        });
    }); }, function (errors) {
        console.log('onSubmit errors', errors);
    });
    return (React.createElement(FormContainer, { formElement: props.type === 'managers'
            ? managerConnects === null || managerConnects === void 0 ? void 0 : managerConnects.map(function (managerIdConnect) {
                return (React.createElement(FluidSelect, { inputProps: {
                        showSearch: true,
                        allowClear: true,
                        options: managers === null || managers === void 0 ? void 0 : managers.map(function (manager) {
                            return {
                                value: manager.id,
                                label: manager.displayName
                            };
                        })
                    }, label: managerIdConnect.bizItemName, key: managerIdConnect.bizItemId, controlProps: { control: form.control, name: "".concat(managerIdConnect.bizItemId) } }));
            })
            : productConnects === null || productConnects === void 0 ? void 0 : productConnects.map(function (product) {
                return (React.createElement(FluidSelect, { inputProps: {
                        filterSort: function (optionA, optionB) {
                            return optionA.label.localeCompare(optionB.label.toLowerCase());
                        },
                        filterOption: function (input, option) {
                            if (option &&
                                option.label &&
                                option.label.includes &&
                                option.label.includes(input)) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        },
                        showSearch: true,
                        allowClear: true,
                        options: orderBy(storeProducts === null || storeProducts === void 0 ? void 0 : storeProducts.map(function (storeProduct) {
                            return {
                                value: storeProduct.id,
                                label: storeProduct.nameWithGroupName
                            };
                        }), 'label', 'desc')
                    }, label: "(".concat(product.categoryName, ") ").concat(product.optionName), key: product.optionId, controlProps: { control: form.control, name: "".concat(product.optionId) } }));
            }), visible: !!form.formState.isDirty, onConfirm: form.handleSubmit(onSubmit), onCancel: handleReset }));
};
var FormContainer = function (props) {
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
        React.createElement("form", { style: { flex: 1, paddingBottom: '70px' } }, props.formElement),
        React.createElement(FloatingButtonGroup, { visible: props.visible, confirmButtonProps: {
                onClick: props.onConfirm
            }, cancelButtonProps: {
                onClick: props.onCancel
            } })));
};
var FluidSelect = styled(HookFormInputs.SelectInput)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var Tab = function (props) {
    return (React.createElement(TabWrapper, null,
        React.createElement(TextComponent, { children: props.label })));
};
var Form = styled.form(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  & > * {\n    margin-bottom: 15px;\n  }\n"], ["\n  & > * {\n    margin-bottom: 15px;\n  }\n"])));
var TabWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 5px;\n"], ["\n  padding: 5px;\n"])));
var TabContent = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 15px;\n  max-width: 1080px;\n  margin: 0 auto;\n  height: 100%;\n"], ["\n  padding: 15px;\n  max-width: 1080px;\n  margin: 0 auto;\n  height: 100%;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
